import { useMutation } from '@tanstack/react-query';
import type { CardTokenRequest, CardTokenResponse } from './interfaces';

const baseApiUrl = 'https://api.pagar.me/core/v5';
const appId = import.meta.env.VITE_APP_ID_PK_PAGARME;

export const usePagarmeCardToken = () => {
  const { mutate, isPending } = useMutation<
    CardTokenResponse,
    unknown,
    CardTokenRequest
  >({
    mutationFn: async (params: CardTokenRequest) => {
      const response = await fetch(`${baseApiUrl}/tokens?appId=${appId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          type: 'card',
          card: { ...params },
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao obter token do cartão');
      }

      return response.json();
    },
  });

  return { getCardToken: mutate, isPending };
};
